import React, { useState, useEffect } from "react";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import $ from "jquery";

let interactionDisabled = false;
let apiCallInteraction = false
let rollerStaticImg = [
    {
        bonusAmount: "10",
        imgUrl: "assets/img/GiraLuz/roll-1.png"

    },
    {
        bonusAmount: "20",
        imgUrl: "assets/img/GiraLuz/roll-2.png"

    },
    {
        bonusAmount: "30",
        imgUrl: "assets/img/GiraLuz/roll-3.png"

    },
    {
        bonusAmount: "40",
        imgUrl: "assets/img/GiraLuz/roll-4.png"

    },
    {
        bonusAmount: "50",
        imgUrl: "assets/img/GiraLuz/roll-5.png"

    },
    {
        bonusAmount: "60",
        imgUrl: "assets/img/GiraLuz/roll-6.png"

    },
    {
        bonusAmount: "70",
        imgUrl: "assets/img/GiraLuz/roll-7.png"

    },
    {
        bonusAmount: "80",
        imgUrl: "assets/img/GiraLuz/roll-8.png"

    },
    {
        bonusAmount: "90",
        imgUrl: "assets/img/GiraLuz/roll-9.png"

    },
    {
        bonusAmount: "100",
        imgUrl: "assets/img/GiraLuz/roll-10.png"

    }
]

const GiraLuzBonus = ({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted }) => {
    const [backendImages, setBackendImages] = useState([]);
    const [giraLuzBonuswin, setGiraLuzBonuswin] = useState([]);
    const [rollerWinList, setRollerWinList] = useState([]);
    const [bonusWinSet, setBonusWinSet] = useState(0);
    const [bonusDetails, setBonusDetails] = useState();
    const [rollerSingleBonus, setRollerSingleBonus] = useState([]);
    const [gameTotalWin, setGameTotalWin] = useState(0);


    const playSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.currentTime = 0;
            sound.play();
        }
    };

    const playSoundByIdInLoop = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.currentTime = 0;
            sound.play();
            sound.loop = true;
        }
    };

    const pauseSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    };

    const giraLuzGetImage = () => {
        const payload = {
            bonusType: "Bonus07GiraLuz",
            recordId: gameSessionRecordId,
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            const res = response?.responsePacket;
            let giraLuzBonusPackets = res?.giraLuzBonusPackets;
            let aroundBonusWin = res?.bonusDetails?.characterBonusList;
            let bonusDetails = res?.bonusDetails;
            let totalWinnings = res?.totalWinnings;

            setBonusDetails(bonusDetails)
            setGiraLuzBonuswin(aroundBonusWin)
            setRollerWinList(aroundBonusWin.slice(-3))
            setGameTotalWin(totalWinnings)

            if (giraLuzBonusPackets) {
                // Loop to extend the images to 18
                let extendedImages = [];
                for (let i = 0; i < 18; i++) {
                    extendedImages.push(giraLuzBonusPackets[i % giraLuzBonusPackets.length]);
                }
                setBackendImages(extendedImages);
            }
            if (response?.errorCode !== 0) {
                console.error("API Call Failed:", response?.errorMessage || "Unknown error");
            }
        });
    };

    useEffect(() => {
        if (!apiCallInteraction) {
            apiCallInteraction = true
            giraLuzGetImage();

        }
    }, []);



    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            if (key == "b") {
                handleKeyPressGameStart();
            }
        };

        if (keyboardInput && backendImages.length > 0) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId, backendImages]);

    const ImgBox = ({ img, id }) => (
        <div id={id} className="gamePlay-img-box w-100">
            <img className="unselectImg" src={img.characterImageUrl} alt={img.recordId} />
        </div>
    );

    const handleKeyPressGameStart = () => {
        if (!interactionDisabled) handleClickBox();
    }



    const handleClickBox = () => {
        if (interactionDisabled) return;
        interactionDisabled = true;

        playSoundByIdInLoop("GiraAroundAnim");

        let currentIndex = 0;
        let roundsCompleted = 0;
        const matchId = giraLuzBonuswin?.[0]?.recordId;

        let firstImgBonus = setInterval(() => {
            let prevIndex = (currentIndex - 1 + backendImages.length) % backendImages.length;
            let prevElement = document.getElementById(`img-box-${prevIndex}`);
            if (prevElement) prevElement.classList.remove("selectActiveImg");

            let currentElement = document.getElementById(`img-box-${currentIndex}`);
            if (currentElement) currentElement.classList.add("selectActiveImg");

            currentIndex = (currentIndex + 1) % backendImages.length;

            if (currentIndex === 0) {
                roundsCompleted++;
            }
            if (roundsCompleted >= 2) {
                if (backendImages[currentIndex]?.recordId === matchId) {
                    if (currentElement) {
                        currentElement.classList.add("selectActiveImg");
                    }
                    setTimeout(() => {
                        clearInterval(firstImgBonus);
                    }, 100);

                    pauseSoundById("GiraAroundAnim");
                    playSoundById("GiraStop-end");

                    setTimeout(() => {
                        pauseSoundById('GiraAroundAnim');
                        playSoundByIdInLoop('RollerRunn');
                        [...Array(3)].forEach((_, index) => {
                            let RollerShow = document.getElementById(`giraLuzRoller-${index}`);
                            let QuestionShow = document.getElementById(`giraLuz-ques-${index}`);
                            if (RollerShow && QuestionShow) {
                                RollerShow.classList.remove('d-none');
                                RollerShow.classList.add('d-block');
                                QuestionShow.classList.add('d-none');
                            }
                        });
                    }, 500);
                    setTimeout(() => {
                        pauseSoundById('RollerRunn');
                        playSoundById("GiraStop-end");

                        rollerWinList.forEach((item, index) => {
                            const imgBox = document.getElementById(`rollerWinImg-${index}`);
                            const RollerHide = document.getElementById(`giraLuzRoller-${index}`);
                            if (RollerHide) {
                                RollerHide.classList.add('d-none');
                            }

                            if (imgBox) {
                                imgBox.classList.remove('d-none');
                                imgBox.classList.add('d-block');
                                const matchingImage = rollerStaticImg.find(staticImg => staticImg.bonusAmount === String(item.bonusAmount));
                                if (matchingImage) {
                                    imgBox.src = matchingImage.imgUrl;
                                }
                            }
                        });
                        setBonusWinSet(bonusDetails?.bonus)
                        setRollerSingleBonus(bonusDetails.characterBonusList.slice(-3))
                    }, 3000);

                    setTimeout(() => {
                        onBonusRoundCompleted(gameTotalWin);
                        apiCallInteraction = false;
                        interactionDisabled = false;
                    }, 7000);
                }
            }

        }, 100);
    };





    const loadStaticAudio = () => (
        <div style={{ display: "none" }}>
            <audio controls id="GiraStop-end" className="audioFile">
                <source src="assets/GiraStop.mp3" type="audio/mpeg" />
            </audio>
            <audio controls id="GiraAroundAnim" className="audioFile">
                <source src="assets/GiraAroundAnim.mp3" type="audio/mpeg" />
            </audio>
            <audio controls id="RollerRunn" className="audioFile">
                <source src="assets/Rolos2.mp3" type="audio/mpeg" />
            </audio>
        </div>
    );

    return (
        <>
            <div className="h-100 w-100 position-relative bg-black">
                <img className="h-100 w-100" src="assets/img/GiraLuz/bg.png" alt="Background" />
                <div className="contentPosition p-0">
                    <div className="cauldron-content bg-transparent">
                        <div
                            className="cauldron-inner-content gira-main"
                            onClick={() => {
                                if (!interactionDisabled) handleClickBox();
                            }}
                        >
                            <div className="gira-header">
                                {["headImage-1", "headImage-2", "headImage-3"].map((img, index) => (
                                    <div key={index} className="gira-header-col-1 h-100 position-relative">
                                        <img className="w-100 h-100 position-absolute" src={`assets/img/GiraLuz/${img}.png`} alt={`Header ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                            <div className="gira-gamePlay gap-3 bg-black p-2">
                                {/* Top Row */}
                                <div className="h-25 d-flex gap-3">
                                    {backendImages && backendImages.length > 0 && backendImages.slice(0, 7).map((img, index) => (
                                        <ImgBox key={index} img={backendImages[index]} id={`img-box-${index}`} />
                                    ))}
                                </div>

                                {/* Middle Section */}
                                <div className="h-50 d-flex gap-3 middle-sec">
                                    {/* Left Column */}
                                    <div className="left-div flex-column-reverse d-flex gap-3">
                                        {backendImages && backendImages.length > 0 && backendImages.slice(7, 9).map((img, index) => (
                                            <ImgBox key={index} img={backendImages[(16 + index)]} id={`img-box-${16 + index}`} />
                                        ))}
                                    </div>

                                    {/* Center Section */}
                                    <div className="w-100 bg-white d-flex gap-1 h-100 py-2 px-2">
                                        <div className="w-75 h-100 d-flex gap-2">
                                            {rollerWinList.map((_, index) => (
                                                <div key={index} className="slot-game gap-3">
                                                    <div className="slot-img-box">
                                                        <img id={`giraLuzRoller-${index}`} className="d-none" src="assets/img/GiraLuz/roll.gif" alt="Roll" />
                                                        <img id={`giraLuz-ques-${index}`} src="assets/img/GiraLuz/question.png" alt="?" />
                                                        <img id={`rollerWinImg-${index}`} className="d-none" src="" alt="" />
                                                    </div>
                                                    <div className="slot-btn-box">
                                                        <span className="position-absolute">{rollerSingleBonus[index]?.bonusAmount || 0} </span>
                                                        {index < 2 && (
                                                            <span className="position-absolute vw-3 fw-bold text-danger z-2" style={{ right: "-7.2%" }}>
                                                                +
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="w-25 h-100 flex-column d-flex justify-content-between gap-3">
                                            <div className="gamePlay-dec-board w-100 d-flex align-items-center">
                                                <span className="text-danger vw-2 fw-bold pe-2 pt-4">+</span>
                                                <div className="h-100 w-100 position-relative">
                                                    <img className="w-100 h-100 position-absolute pt-4 start-0" src="assets/img/GiraLuz/gamePlay-img.png" alt="" />
                                                </div>
                                            </div>
                                            <div style={{ height: "40%" }}>
                                                <div className="h-100">
                                                    <div className="d-flex" style={{ height: "40%" }}>
                                                        <span className="text-white vw-2 fw-bold px-3">=</span>
                                                        <div className="h-100 w-100 position-relative">
                                                            <img className="position-absolute h-100 w-100 start-0" src="assets/img/GiraLuz/bonus.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center" style={{ height: "60%" }}>
                                                        <span className="text-danger vw-2 fw-bold px-3">=</span>
                                                        <div className="gamePlay-dec-board-btn h-100 w-100 position-relative bg-black text-white vw-2 d-flex align-items-center justify-content-center border-danger border-4 border fw-bold">
                                                            <span className="position-absolute">{bonusWinSet}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div className="left-div flex-column d-flex gap-3">
                                        {backendImages && backendImages.length > 0 && backendImages.slice(7, 9).map((img, index) => (
                                            <ImgBox key={index} img={backendImages[(7 + index)]} id={`img-box-${7 + index}`} />
                                        ))}
                                    </div>
                                </div>

                                {/* Bottom Row */}
                                <div className="h-25 d-flex gap-3 flex-row-reverse">
                                    {backendImages && backendImages.length > 0 && backendImages.slice(8, 9).map((img, index) => (
                                        <ImgBox key={index} img={backendImages[(9 + index)]} id={`img-box-${9 + index}`} />
                                    ))}
                                    {backendImages && backendImages.length > 0 && backendImages.slice(0, 6).map((img, index) => (
                                        <ImgBox key={index} img={backendImages[(0 + index)]} id={`img-box-${10 + index}`} />
                                    ))}
                                </div>
                            </div>

                            {/* Bottom Section */}
                            <div className="gira-bottom-div p-2">
                                {backendImages && backendImages.length > 0 && backendImages.slice(0, 10).map((img, index) => (
                                    <div className="img-nu-box d-flex position-relative align-items-center justify-content-center" key={index}>
                                        <span className="vw-2 position-absolute fw-bold text-black z-1">=</span>
                                        <div className="w-50 h-100 position-relative">
                                            <img className="w-100 h-100 position-absolute start-0 bg-white p-1" src={img.characterImageUrl} alt={img.recordId} />
                                        </div>
                                        <div className="w-50 h-100 position-relative bg-danger d-flex justify-content-center align-items-center">
                                            <span className="vw-2 position-absolute fw-bold text-black">{(index + 1) * 10}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loadStaticAudio()}
        </>
    );
};

export default GiraLuzBonus;
